export default "__VITE_ASSET__DRd0oYMr__"